function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { DragSource, DropTarget } from 'react-dnd';
import TreeNode from './treeNode';
import { treeNodeTarget, dropCollect, treeNodeSource, dragCollect } from './treeNodeTarget';
class TreeNodeDragDrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }
  toggleExpanded() {
    const {
      expanded
    } = this.state;
    this.setState({
      expanded: !expanded
    });
  }
  hasTarget() {
    const {
      node,
      target
    } = this.props;
    return !_.isNull(target) && (target.id === 'dummy' && target.parentID === node.id || node.nodes.some(currentNode => currentNode.id === target.id));
  }
  render() {
    const {
      node,
      connectDragSource,
      connectDropTarget,
      level,
      index,
      isLast
    } = this.props;
    const {
      expanded
    } = this.state;
    const children = [];
    if (node.nodes) {
      const sorted = _.sortBy(node.nodes, 'sortOrder');

      // add a target after children if needed.
      if (this.hasTarget()) {
        sorted.push({
          id: 'dummy',
          name: ' ',
          parentID: node.id,
          sortOrder: 99999
        });
      }
      sorted.forEach((currentNode, i) => {
        const addLevel = currentNode.id === 'dummy' ? 0 : 1;
        const props = _objectSpread(_objectSpread({}, this.props), {}, {
          node: currentNode,
          ref: `treeNode-${currentNode.id}`,
          key: currentNode.id,
          level: level + addLevel,
          isLast: node.nodes.length - 1 === i,
          index: i
        });
        children.push(/*#__PURE__*/React.createElement(WrappedTree, props));
      });
    }
    let childContainer = null;
    if (children.length > 0) {
      let classStr = 'tree-sub-nodes';
      if (expanded) {
        classStr += ' expanded';
      }
      childContainer = /*#__PURE__*/React.createElement("ul", {
        className: classStr
      }, " ", children, " ");
    }

    // when dragging over a node, we display a target div.
    const lastChild = index === children.length - 1;
    const lastSelector = isLast || lastChild ? 't-tn-last' : '';
    return connectDragSource(connectDropTarget(/*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TreeNode, _objectSpread(_objectSpread({
      lastSelector: lastSelector
    }, this.props), {}, {
      expanded: expanded,
      toggleExpanded: this.toggleExpanded
    }), expanded ? childContainer : null))));
  }
}
TreeNodeDragDrop.defaultProps = {
  draggingId: null,
  isLast: false,
  index: 0,
  target: null
};
TreeNodeDragDrop.propTypes = {
  isLast: PropTypes.bool,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  draggingId: PropTypes.string,
  isDragging: PropTypes.bool.isRequired,
  level: PropTypes.number.isRequired,
  index: PropTypes.number,
  node: PropTypes.shape({
    nodes: PropTypes.arrayOf(PropTypes.shape({})),
    state: PropTypes.string,
    id: PropTypes.string,
    nodeId: PropTypes.number
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string,
    parentID: PropTypes.string
  })
};

/* we need to define the wrapped drag and drop TreeNodeDragDrop, and use that
 * in any recursive declarations of TreeNodeDragDrop within this file, or they
 * won't get the drag and drop functionality - and will cause errors
 */
const WrappedTree = DropTarget('TreeNodeDragDrop', treeNodeTarget, dropCollect)(DragSource('TreeNodeDragDrop', treeNodeSource, dragCollect)(TreeNodeDragDrop));
export default WrappedTree;